import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { Observable } from 'rxjs/Rx';
import { Store } from '@ngrx/store';
import { Response, Headers, RequestOptionsArgs, RequestOptions, Http } from '@angular/http';

import { IApplicationState } from '../../stateManagement/states/applicationState';
import * as commonTypes from '../types';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';

@Injectable()
export class PortalInfoService extends BaseHttpService {
  portal: string = _.has(environment, 'portal') ? environment['portal'] : location.host;

  constructor(private http: Http, store: Store<IApplicationState>) {
    super(store);
  }

  getPortalInfo(): Observable<commonTypes.IPortalInfo> {
    return this.http.get(`portal/${this.portal}`).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/portalInfo.service.ts